"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.fakeLoginDRPicasoInitializer = exports.fakeLoginInitializer = void 0;
const web_ui_framework_1 = require("@gruposantander/web-ui-framework");
const session_initializer_1 = require("../../security/session/session.initializer");
const authoriser_initializer_1 = require("../../security/authoriser/authoriser.initializer");
const xhr_initalizer_1 = require("../../xhr/xhr.initalizer");
const authenticator_initializers_1 = require("../../security/authenticator/authenticator.initializers");
const locale_initializers_1 = require("../../locale/locale.initializers");
const uiInformation_initializer_1 = require("../../uiInformation/uiInformation.initializer");
const eventBus_initializer_1 = require("../../eventBus/eventBusManager/eventBus.initializer");
const fakeLoginInitializer = async (config) => {
    const eventBus = new eventBus_initializer_1.EventBusInitializer();
    const sessionInit = new session_initializer_1.SessionInitializer(config, eventBus);
    const authoriserInit = new authoriser_initializer_1.AuthoriserInitializer();
    const localeInit = new locale_initializers_1.LocaleInitializer(config.language);
    const deviceUUID = new uiInformation_initializer_1.DeviceUUIDInitializer();
    const APIInit = new xhr_initalizer_1.XhrInitializer(config, sessionInit, authoriserInit, localeInit);
    const initializers = {
        locale: localeInit,
        session: sessionInit,
        authoriser: authoriserInit,
        API: APIInit,
        authenticator: new authenticator_initializers_1.AuthenticatorInitializer(config, sessionInit, authoriserInit),
        deviceUUID,
        eventBus,
    };
    const initializerManager = new web_ui_framework_1.InitializerManager(initializers);
    const initialized = await initializerManager.launchInitializers();
    return {
        authenticator: initialized.authenticator.getInitialized(),
    };
};
exports.fakeLoginInitializer = fakeLoginInitializer;
const fakeLoginDRPicasoInitializer = async (config) => {
    const eventBus = new eventBus_initializer_1.EventBusInitializer();
    const authoriser = new authoriser_initializer_1.AuthoriserInitializer();
    const locale = new locale_initializers_1.LocaleInitializer(config.language);
    const session = new session_initializer_1.SessionDRPicasoInitializer(config, eventBus);
    const API = new xhr_initalizer_1.XhrInitializer(config, session, authoriser, locale);
    const authenticator = new authenticator_initializers_1.AuthenticatorDRPicasoInitializer(config, session);
    const initializers = {
        locale,
        session,
        authoriser,
        API,
        authenticator,
        eventBus,
    };
    const initializerManager = new web_ui_framework_1.InitializerManager(initializers);
    const initialized = await initializerManager.launchInitializers();
    return {
        session: initialized.session.getInitialized(),
        authenticator: initialized.authenticator.getInitialized(),
    };
};
exports.fakeLoginDRPicasoInitializer = fakeLoginDRPicasoInitializer;
//# sourceMappingURL=fakeLogin.initializers.js.map